<section class="cards-container">
  <!-- PACIENTES EN ESPERA -->
  <div class="card">
    <div class="card-icon">
      <mat-icon>group</mat-icon>
    </div>

    <div class="card-content">
      <div class="card-header">
        <h3>Pacientes en espera</h3>
      </div>

      <div class="card-body">
        <p class="number">{{ pendientes }}</p>
      </div>

      <div class="card-footer">
        <button (click)="mostrarTodos()">Ver todos ({{ totalPendientes }})</button>
      </div>
    </div>
  </div>

  <!-- CONSULTAS -->
  <div class="card">
    <div class="card-icon">
      <mat-icon class="material-symbols-outlined"> person_check </mat-icon>
    </div>

    <div class="card-content">
      <div class="card-header">
        <h3>Consultas atendidas</h3>
      </div>

      <div class="card-body">
        <p class="number">{{ consultasHoy }}</p>
      </div>

      <div class="card-footer">
        <button (click)="abrirDashboard()">Ver pacientes</button>
      </div>
    </div>
  </div>

  <!-- PRÓXIMA CONSULTA -->
  <div class="card card-next">
    <div class="card-icon">
      <mat-icon class="material-symbols-outlined"> stethoscope_arrow </mat-icon>
    </div>

    <div class="card-content">
      <div class="card-header">
        <h3>Próxima consulta</h3>
      </div>

      <div class="card-body-next">
        @if (proximaConsulta) {
          <strong>
            {{ proximaConsulta.paciente?.nombre }}
            {{ proximaConsulta.paciente?.apellido }}
            {{ proximaConsulta.paciente?.segundoApellido }}
          </strong>

          <span>
            {{ proximaConsulta.horaLlegada | date: 'HH:mm' }}
          </span>
        } @else {
          <span class="sin-proxima-consulta"> No hay pacientes en espera </span>
        }
      </div>

      @if (proximaConsulta && (rol === 'ADMIN' || rol === 'MEDIC@')) {
        <button
          class="btn-proxima-consulta"
          mat-icon-button
          color="accent"
          (click)="abrirConsulta(proximaConsulta)"
          matTooltip="Enviar a consulta"
        >
          <mat-icon>send</mat-icon>
        </button>
      }
    </div>
  </div>
</section>
